module.exports = __webpack_public_path__ + "components/outside-promo-page/static/app-card-mountain-b70059f36d437fed5afc3dfd1f02b854.webp";